import { enCurrency } from 'interfaces/IProductData';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs';

export class CurrencyService {
  private currency$ = new BehaviorSubject<enCurrency>(enCurrency.BRL);
  private availableCurrencies$ = new BehaviorSubject<enCurrency[]>([enCurrency.BRL]);

  public getIsInternacional() {
    return this.availableCurrencies$.value.length > 1;
  }

  public setAvailableCurrencies(currencies: enCurrency[]) {
    this.availableCurrencies$.next(currencies);
  }

  public setCurrency(currency: enCurrency) {
    const avaibleCurrencies = this.availableCurrencies$.value;

    if (avaibleCurrencies.includes(currency)) {
      this.currency$.next(currency);

      return;
    }
  }

  public getCurrency(): Observable<enCurrency> {
    return this.currency$.asObservable().distinctUntilChanged();
  }
}

// tslint:disable-next-line:variable-name
export const CurrencyServiceFactory = () => new CurrencyService();

export const currencyService = CurrencyServiceFactory();
